import PropTypes from 'prop-types';
import React from 'react';
import Spinner from 'shared-assets/components/Spinner';

const Loader = ({ children, condition, size, style, thickness, rgb }) => {
  return (
    <Choose>
      <When condition={condition}>{children}</When>
      <Otherwise>
        <Spinner thickness={thickness} rgb={rgb} style={style} size={size} />
      </Otherwise>
    </Choose>
  );
};
Loader.defaultProps = {
  thickness: '5px',
  size: '2rem',
  rgb: [0, 0, 0],
  children: undefined,
  style: {
    position: 'absolute',
    left: '45%',
    top: '35%',
  },
};

Loader.propTypes = {
  condition: PropTypes.bool.isRequired,
  thickness: PropTypes.string,
  size: PropTypes.string,
  rgb: PropTypes.arrayOf(PropTypes.number.isRequired),
  children: PropTypes.node,
  style: PropTypes.object,
};

export default Loader;
